// Where leads and their tags come from (SPEC §4). The portal keeps only the lead code, tags and the masked mobile;
// the mobile itself is fetched from the registry at send time and logged there (pi_access_log).
import { z } from 'zod'
import { CountAnswer, Id, IsoDateTime } from './common'

export const SourceStatus = z.enum(['connected', 'later'])
export type SourceStatus = z.infer<typeof SourceStatus>

export const DataSource = z.object({
  id: Id,
  name: z.string(),
  how: z.string().describe('the event or API the leads arrive through'),
  status: SourceStatus,
  last_sync: IsoDateTime.nullable(),
  lead_count: z.number().int().min(0),
})
export type DataSource = z.infer<typeof DataSource>

/** A channel partner's slug, as the partner portal names it (partner:<slug> tags). */
export const PartnerSlug = z
  .string()
  .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
  .max(60)
/** 2026-10-28: the real partners this portal knows (their leads arrived, or they have a partner API key; firstfund
 *  always), for the partner pickers instead of a fixed list. */
export const PartnerOption = z.object({ slug: PartnerSlug, lead_count: z.number().int().min(0) })
export type PartnerOption = z.infer<typeof PartnerOption>

export interface SourcesApi {
  listSources(): Promise<DataSource[]>
  listPartners(): Promise<PartnerOption[]>
  /** pulls what is new from the source now; count = new leads */
  fetchSourceNow(id: string): Promise<CountAnswer>
}
